import './rotateControl.css';
import {Control} from 'ol/control';
import {lang, baseRotation} from '/main';

export class RotateControl extends Control {
  /**
   * Constructor
   * @param {Object} [opt_options] Control options
   */
  constructor(opt_options) {
    const options = opt_options || {}

    const element = document.createElement('div');
    element.className = 'ol-unselectable ol-control';

    const button = document.createElement('button');

    if (typeof options.direction !== 'undefined') {
      if (options.direction == 'left') {
        button.setAttribute('title', lang['rotateControlRotateLeftTitle']);
        button.innerHTML = '<i class="fas fa-undo"></i>';
        element.classList.add('ol-rotate-left');
      } else if (options.direction == 'right') {
        button.setAttribute('title', lang['rotateControlRotateRightTitle']);
        button.innerHTML = '<i class="fas fa-redo"></i>';
        element.classList.add('ol-rotate-right');
      } else if (options.direction == 'reset') {
        button.setAttribute('title', lang['rotateControlResetRotationTitle']);
        button.innerHTML = '<i class="fas fa-sync"></i>';
        element.classList.add('ol-reset-rotation');
      }
    }

    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    this.direction = options.direction || null;

    button.addEventListener('click', this.handleRotation.bind(this), {passive: true});
    button.addEventListener('touchstart', this.handleRotation.bind(this), {passive: true});
  }

  handleRotation() {
    let rotationValue = baseRotation;
    if (this.direction !== null) {
      if (this.direction == 'left') {
        rotationValue = (-Math.PI / 2);
      } else if (this.direction == 'right') {
        rotationValue = (Math.PI / 2);
      }
    }

    this.getMap().getView().animate({
      rotation: this.getMap().getView().getRotation() + rotationValue,
    });
  }
}